import React from "react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

interface FeatureItem {
  id: number;
  icon: string;
  title: string;
  description?: string;
}

interface PersonalTouchProps {
  className?: string;
  data: FeatureItem[];
  title: string;
}

const PersonalTouchSection: React.FC<PersonalTouchProps> = ({ className = "", data, title }) => {
  return (
    <section className={`relative py-16 ${className}`}>
      <div className="container mx-auto">
        <h2 className="text-4xl font-semibold mb-16">{title}</h2>

        <div className="relative">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={1.2}
            loop={false}
            className="!overflow-visible"
            breakpoints={{
              640: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
            }}
          >
            {data.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="bg-gray-100 rounded-3xl p-8 h-full">
                  {/* Icon */}
                  <div className="mb-6">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                      <img src={item.icon} alt="" className="w-8 h-8 object-contain" />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-md font-normal mb-4">{item.title}</h3>
                  {item.description && <p className="text-gray-600">{item.description}</p>}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default PersonalTouchSection;
